import * as React from "react"

const InfoCircled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" {...props}>
    <path d="M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1zM2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8zm6.8-3.2a.8.8 0 1 1-1.6 0 .8.8 0 0 1 1.6 0zM6.4 6.4H8a.5.5 0 0 1 .5.5v3.8h1.1v1H6.4v-1h1V7.5h-1V6.4z" />
  </svg>
)

export default InfoCircled
